import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42322c7b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user_con" }
const _hoisted_2 = { class: "right_con" }
const _hoisted_3 = { style: {"margin":"0"} }
const _hoisted_4 = { class: "sub_title" }
const _hoisted_5 = { class: "demo" }
const _hoisted_6 = { class: "item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "文章数量")
], -1))
const _hoisted_8 = { class: "num" }
const _hoisted_9 = { class: "item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "行业数量")
], -1))
const _hoisted_11 = { class: "num" }
const _hoisted_12 = { class: "item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "用户日活量")
], -1))
const _hoisted_14 = { class: "num" }
const _hoisted_15 = { class: "item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "用户量")
], -1))
const _hoisted_17 = { class: "num" }
const _hoisted_18 = { class: "item" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "浏览量")
], -1))
const _hoisted_20 = { class: "num" }
const _hoisted_21 = {
  key: 0,
  id: "mycharts",
  ref: "myRef",
  class: "chart-box",
  style: {"width":"100%","height":"450px"}
}
const _hoisted_22 = { key: 1 }
const _hoisted_23 = {
  id: "mycharts2",
  ref: "myRef2",
  class: "chart-box2",
  style: {"width":"100%","height":"550px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_countTo = _resolveComponent("countTo")!
  const _component_a_empty = _resolveComponent("a-empty")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { class: "home" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_a_avatar, {
            size: 70,
            style: {"backgroundColor":"#87d068"}
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_UserOutlined)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h2", _hoisted_3, "欢迎进入" + _toDisplayString(_ctx.appId.includes('2022051902') ? '智慧党建后台管理' : '数字商协后台管理') + "系统，祝你开心每一天！", 1),
            _createElementVNode("div", _hoisted_4, "更新时间" + _toDisplayString(_ctx.updata_time), 1)
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_countTo, {
              startVal: 0,
              endVal: _ctx.article_sum,
              duration: 3000
            }, null, 8, ["endVal"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_countTo, {
              startVal: 0,
              endVal: _ctx.costomser_sum,
              duration: 3000
            }, null, 8, ["endVal"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_countTo, {
              startVal: 0,
              endVal: _ctx.user_day_sum,
              duration: 3000
            }, null, 8, ["endVal"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_countTo, {
              startVal: 0,
              endVal: _ctx.user_sum,
              duration: 3000
            }, null, 8, ["endVal"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_countTo, {
              startVal: 0,
              endVal: _ctx.visit_num,
              duration: 3000
            }, null, 8, ["endVal"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_a_card, {
      title: '文章数量统计：总计'+'('+_ctx.article_sum+')' ,
      style: {"margin-top":"20px","height":"600px","width":"50%"}
    }, {
      default: _withCtx(() => [
        (_ctx.article_sum !== 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, null, 512))
          : _createCommentVNode("", true),
        (_ctx.article_sum == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createVNode(_component_a_empty, { style: {"padding-top":"40px"} })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_a_card, {
      title: "各行业会员数量统计",
      style: {"margin-top":"-600px","height":"600px","width":"49%","margin-left":"51%"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_23, null, 512)
      ]),
      _: 1
    })
  ]))
}